import { render } from "./OfficeMapPage.vue?vue&type=template&id=29cbf054"
import script from "./OfficeMapPage.vue?vue&type=script&lang=js"
export * from "./OfficeMapPage.vue?vue&type=script&lang=js"

import "./OfficeMapPage.vue?vue&type=style&index=0&id=29cbf054&lang=css"

import exportComponent from "/Users/elenejikia/Desktop/Parsons/Studio2/major-studio-2-sp24-1/06-vue-scrollytelling/vue-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__